export default __webpack_public_path__ + "static/media/follow-guild.464adbbe.webp";